// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(message_text, vehicle_category, geo_region) {
  vehicle_category !== 0;
  return {
          title_text: "కాన్సలేషన్ స్కోర్",
          learn_more_text: "ఇంకా తెలుసుకోండి",
          info_btn_details: {
            video_url: undefined,
            question: "కాన్సలేషన్ స్కోర్ ఎలా లెక్కించబడుతుంది?",
            answer: "మీరు ఆమోదించిన చివరి 30 ఆర్డర్‌లలో డ్రైవర్‌కు ఆపాదించబడిన మొత్తం కాన్సలేషన్ల సంఖ్య ఆధారంగా కాన్సలేషన్ స్కోర్ లెక్కించబడుతుంది."
          },
          learn_more_btn_details: [
            {
              video_url: PartnerContentHelper.getV2LearnMoreVid(geo_region),
              question: "కాన్సలేషన్ స్కోర్ అంటే ఏమిటి మరియు అది ఎందుకు ముఖ్యమైనది?",
              answer: ""
            },
            {
              video_url: undefined,
              question: "నేను ఎప్పుడు సస్పెండ్ చేయబడతాను?",
              answer: "మీరు ఒక నిర్దిష్ట స్థాయిని దాటినప్పుడల్లా, తదనుగుణంగా మీరు కొంత కాలం పాటు సస్పెండ్ చేయబడతారు."
            },
            {
              video_url: undefined,
              question: "ప్రతి స్థాయికి సస్పెన్షన్ వ్యవధి ఎంత?",
              answer: "ప్రతి స్థితికి సంబంధించిన సస్పెన్షన్ వ్యవధిని సస్పెన్షన్ గైడ్‌లో చూడవచ్చు."
            },
            {
              video_url: undefined,
              question: "నేను కాన్సలేషన్ స్కోర్‌ను ఎందుకు చూడలేకపోతున్నాను?",
              answer: "ఇటీవలి నెలల్లో కనీసం 30 ఆర్డర్‌లు ఆమోదించిన పార్ట్నర్లకు మాత్రమే కాన్సలేషన్ స్కోర్ లెక్కించబడుతుంది."
            }
          ],
          locked_score_msg: "కాన్సలేషన్ స్కోర్‌ని అన్‌లాక్ చేయడానికి మరిన్ని ఆర్డర్‌లను అంగీకరించండి.",
          message_text: message_text,
          suspension_guide_text: "సస్పెన్షన్ గైడ్",
          suspension_guide_table_details: {
            cancellation_score_text: "కాన్సలేషన్ స్కోర్",
            suspension_days_text: "సస్పెన్షన్ రోజులు"
          }
        };
}

export {
  getContent ,
  
}
/* No side effect */
